import { getCookie } from 'cookies-next';
import { TOPSORT_USER_ID } from 'constants/browserStorageNames';
import { browserLogger } from 'utils/logger/browserLogger';
import { TOPSORT_URL_AUCTIONS } from 'constants/topsort';

export interface TopsortBannerData {
  id: string;
  imageUrl: string;
  url: string;
  resolvedBidId: string;
}

const TOPSORT_TOKEN = process.env.NEXT_PUBLIC_TOPSORT_TOKEN || '';

export async function getTopsortBanner(idBanner: string, isMobile: boolean) {
  if (!TOPSORT_TOKEN) {
    browserLogger().error({
      message: 'Topsort Token not found.',
      data: 'TOPSORT_TOKEN environment variable not found.'
    });
    return;
  }
  const topsortUserId = getCookie(TOPSORT_USER_ID);
  const deviceType = isMobile ? 'mobile' : 'desktop';
  try {
    const response = await fetch(TOPSORT_URL_AUCTIONS, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${TOPSORT_TOKEN}`
      },
      body: JSON.stringify({
        auctions: [
          {
            slots: 1,
            type: 'banners',
            device: deviceType,
            slotId: idBanner,
            opaqueUserId: topsortUserId
          }
        ]
      })
    });

    if (!response.ok) throw new Error('Topsort Auction failed');

    const data = await response.json();

    if (data.results.length > 0 && data.results[0].winners.length > 0) {
      const winner = data.results[0].winners[0];
      const imageUrl = winner.asset?.[0]?.url || '';
      let destinationUrl = winner.id;
      if (winner.type === 'product') {
        destinationUrl = `https://www.sympla.com.br/evento/${winner.id}`;
      } else if (winner.type === 'vendor') {
        destinationUrl = `https://www.sympla.com.br/produtor/${winner.id}`;
      }

      if (imageUrl && destinationUrl) {
        const bannerData: TopsortBannerData = {
          id: winner.campaignId,
          imageUrl: imageUrl,
          url: destinationUrl,
          resolvedBidId: winner.resolvedBidId
        };
        return bannerData;
      }
    }
    return null;
  } catch (error) {
    browserLogger().error({
      message: 'Error reporting get Topsort banner',
      data: String(error)
    });
  }
}
